import { addModal } from 'weblite-web-modal-viewer'
import { EditProfileDialog } from './edit-profile-dialog'

const COMPONENT_ID = 'editProfileDialog'

export const showEditProfileDialog = (
  props: Omit<Parameters<typeof EditProfileDialog>[0], 'isOpen'>,
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: EditProfileDialog,
  },
}
